import type { PayloadActionType } from 'storeContext/reducers/createReducer'
import type { BoMListItemType, BoMListResponseType, BoMQueryType } from 'utils/apiList/bom'
import createReducer from 'storeContext/reducers/createReducer'
import { SET_IS_LOADING, SET_QUERY, SET_BOMS, SET_PRODUCTS } from 'storeContext/actionsType/bom'

export type BoMStateType = {
  isLoading: boolean
  query: BoMQueryType
  pagination: {
    pageSize?: number
    currentPage?: number
    totalPage?: number
  }
  data: BoMListItemType[]
  products: BoMListItemType[]
}

export type BoMQueryPayloadType = {
  query: BoMQueryType
  params?: unknown
}

export const initialStateBoM: BoMStateType = {
  isLoading: false,
  query: {
    pageIndex: 0,
  },
  pagination: {},
  data: [],
  products: [],
}

const bomReducer = createReducer<BoMStateType>({
  [SET_IS_LOADING]: (state, action: PayloadActionType<boolean>) => {
    state.isLoading = action.payload
  },
  [SET_QUERY]: (state, action: PayloadActionType<BoMQueryPayloadType>) => {
    state.isLoading = true
    state.query = {
      ...state.query,
      ...action.payload.query,
    }
  },
  [SET_BOMS]: (state, action: PayloadActionType<BoMListResponseType>) => {
    const { data, pagination } = action.payload
    const { pageSize, pageIndex, totalElement } = pagination

    state.data = data
    state.pagination = {
      pageSize,
      currentPage: pageIndex,
      totalPage: Math.ceil(totalElement / pageSize),
    }
    state.isLoading = false
  },
  [SET_PRODUCTS]: (state, action: PayloadActionType<BoMListResponseType>) => {
    state.products = action.payload.data
  },
})

export default bomReducer
